/** @format */

export interface ProductStatLine {
  highlight: 'true' | 'false';
  title: string;
}

export interface HomrProductStatsSlider {
  productStatLine: ProductStatLine[];
  title: string;
}
